export default __webpack_public_path__ + "static/media/404_page_not_found_.f5aed666.svg";